import { useQuery } from '@tanstack/react-query';

import { fulfillmentLifecycleApi } from 'api/fulfillmentLifecycle';

const ORDER_SOURCES_QUERY_KEY = 'fulfillmentLifecycleOrderSources';

const EMPTY_SOURCE_DATA = { groups: [], sources: [] };

const normalizeOrderSourceData = (data) => {
    const groups = Array.isArray(data?.groups)
        ? data.groups
              .filter(
                  (group) =>
                      group &&
                      typeof group.key === 'string' &&
                      typeof group.label === 'string' &&
                      Array.isArray(group.values),
              )
              .map((group) => ({
                  key: group.key,
                  label: group.label,
                  values: group.values.filter((value) => typeof value === 'string'),
              }))
        : [];

    const sources = Array.isArray(data?.sources)
        ? data.sources
              .filter((source) => source && typeof source.value === 'string' && typeof source.label === 'string')
              .map((source) => ({
                  value: source.value,
                  label: source.label,
              }))
        : [];

    return { groups, sources };
};

function useOrderSourcesQuery() {
    const { data = EMPTY_SOURCE_DATA } = useQuery({
        queryFn: async ({ signal }) => {
            const res = await fulfillmentLifecycleApi.getOrderSources({ signal });
            if (!res.status) {
                throw new Error(res.msg ?? 'Failed to fetch order sources');
            }
            return normalizeOrderSourceData(res.data);
        },
        queryKey: [ORDER_SOURCES_QUERY_KEY],
        staleTime: 10 * 60_000,
        gcTime: 30 * 60_000,
    });

    return data;
}

export { useOrderSourcesQuery, ORDER_SOURCES_QUERY_KEY, normalizeOrderSourceData };
